<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-04-28 17:14:42
 * @Description: h5Player组件，支持预览、云台操作、历史回放
 * @LastEditors: Please set LastEditors
-->

<template>
  <div class="h-100">
    <el-row class="h-100" :class="isDarkStyle ? 'darkStyle' : ''">
      <el-col :span="showControl && leftBarSwitch ? 18 : 24" class="h-100 position-relative">
        <iframe
          id="play_wind"
          ref="h5Frame"
          class="h-100 w-100"
          :src="iframUrl"
          @load="iframeOnload()"
          scrolling="no"
        ></iframe>
        <i
          class="iconfont icon-fullscreen fz-18 position-absolute text-color-white full_screen"
          @click="fullScreen"
        ></i>
        <div v-if="showControl" class="arrows" @click="leftBarSwitch = !leftBarSwitch">
          <span
            class="fz-16 iconfont"
            :class="leftBarSwitch ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
          ></span>
        </div>
      </el-col>
      <el-col :span="showControl && leftBarSwitch ? 6 : 0" class="h-100 p-5 w-50 position-relative">
        <div class="h-50">
          <div class="fz-14 darkStyle_text">云台控制</div>
          <div class="m-t-10">
            <el-date-picker
              size="mini"
              v-model="backStartTime"
              popper-class="document_select-popper"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
          <el-row class="m-t-10 flex flex-row-center-center darkStyle_button">
            <el-button type="primary" size="mini" @click="startPlay()" :disabled="isBackPlay"
              >开始回放</el-button
            >
            <el-button
              type="primary"
              size="mini"
              :disabled="!isBackPlay"
              @click="playControl('stopPlay')"
              >停止回放</el-button
            >
          </el-row>
          <el-row class="m-t-10 flex flex-row-center-center">
            <el-button
              v-if="isPausePlay"
              class="m-l-5 p-5"
              size="mini"
              type="primary"
              icon="iconfont icon-fa-play"
              :disabled="!isBackPlay"
              @click="playControl('resumePlay')"
            ></el-button>
            <el-button
              v-if="!isPausePlay"
              @click="playControl('pausePlay')"
              class="m-l-5"
              size="mini"
              type="primary"
              icon="iconfont icon-pause"
              :disabled="!isBackPlay"
            ></el-button>
            <el-button
              class="m-l-5"
              size="mini"
              type="primary"
              icon="iconfont icon-bg-backward"
              :disabled="!(backSpeed > 0.125) || !isBackPlay"
              @click="playControl('slowPlay')"
            ></el-button>
            <el-button
              class="m-l-5"
              size="mini"
              type="primary"
              icon="iconfont icon-bg-forward"
              :disabled="!(backSpeed < 8) || !isBackPlay"
              @click="playControl('fastPlay')"
            ></el-button>
            <el-button
              class="m-l-5"
              size="mini"
              type="primary"
              icon="iconfont icon-refresh"
              @click="refreshPlay()"
              :disabled="!isBackPlay"
            ></el-button>
          </el-row>
        </div>
        <div class="h-50">
          <div class="m-b-20">
            <div class="tc">
              <img
                :disabled="!isBackPlay"
                class="controlImg controlImg_up cur-pointer"
                src="/static/img/bc/arrows.png"
                @mousedown="controlCamera('up', 0)"
                @mouseup="controlCamera('up', 1)"
              />
            </div>
            <div class="tc">
              <img
                class="controlImg cur-pointer"
                src="/static/img/bc/arrows.png"
                @mousedown="controlCamera('left', 0)"
                @mouseup="controlCamera('left', 1)"
              />
              <img
                class="controlImg controlImg_right cur-pointer"
                src="/static/img/bc/arrows.png"
                @mousedown="controlCamera('right', 0)"
                @mouseup="controlCamera('right', 1)"
              />
            </div>
            <div class="tc">
              <img
                class="controlImg controlImg_down cur-pointer"
                src="/static/img/bc/arrows.png"
                @mousedown="controlCamera('down', 0)"
                @mouseup="controlCamera('down', 1)"
              />
            </div>
          </div>
          <div>
            <el-select
              popper-class="document_select-popper"
              v-model="speed"
              size="mini"
              placeholder="请选择云台速度"
            >
              <el-option
                v-for="item in speedOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    showControl: {
      type: Boolean,
      default: false,
    },
    cameraIndexCodeList: {
      type: Array,
      default: null,
    },
    isDarkStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iframUrl: '',
      backStartTime: '',
      backEndTime: '',
      speed: '',
      speedOptions: [1, 4, 6, 10],
      isBackPlay: false,
      backSpeed: 1,
      isPausePlay: false,
      leftBarSwitch: true,
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handlerMessage, false)
  },
  computed: {
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    H5playerProtocol() {
      const systemParams = this.$store.getters.systemParams || []
      const obj = _.find(systemParams, { parameterCode: 'H5playerProtocol' })
      return obj ? obj.parameterValue : ''
    },
  },
  watch: {
    cameraIndexCodeList() {
      this.$refs.h5Frame.contentWindow.postMessage(
        {
          cameraIndexCodeList: _.uniq(this.cameraIndexCodeList),
          currentCode: this.cameraIndexCodeList[this.cameraIndexCodeList.length - 1],
        },
        '*'
      )
    },
    leftBarSwitch() {
      this.$refs.h5Frame.contentWindow.postMessage({ isFull: true }, '*')
    },
  },
  methods: {
    // 监控画面加载
    async iframeOnload() {
      // const authCode = await LocalForage.getItem('authCode')
      this.iframUrl = `${currentEnv.VUE_APP_PLANT_SERVER}/player/demo.html`
      // this.iframUrl = 'http://127.0.0.1:5500/demo.html' // 本地测试
      this.$refs.h5Frame.contentWindow.postMessage(
        {
          EASCServer: currentEnv.VUE_APP_EASC_SERVER,
          APIServer: currentEnv.VUE_APP_PLANT_SERVER,
          AppId: currentEnv.VUE_APP_APP_ID,
          cameraIndexCodeList: _.uniq(this.cameraIndexCodeList),
          protocol: this.H5playerProtocol,
        },
        '*'
      )
    },
    // 监控全屏
    fullScreen() {
      const element = document.getElementById('play_wind')
      if (element.requestFullScreen) {
        element.requestFullScreen()
      } else if (element.mozRequestFullScreen) {
        // 兼容moz
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullScreen) {
        // 兼容webkit
        element.webkitRequestFullScreen()
      }
      this.$refs.h5Frame.contentWindow.postMessage({ isFull: true }, '*')
    },
    // 控制摄像头移动
    controlCamera(command, action) {
      if (this.isBackPlay && action !== 1) {
        this.$message.error('回放状态，无法操作摄像头')
        return
      }
      const control = { command, action, speed: this.speed || 4 }
      this.$refs.h5Frame.contentWindow.postMessage({ control: JSON.stringify(control) }, '*')
    },

    /**
     * @description: 开始回放
     * @param {*}
     * @return {*}
     */
    startPlay() {
      if (this.backStartTime === '') {
        this.$message.warning('请先选择开始时间')
        return
      }
      this.isBackPlay = !this.isBackPlay
      const backStartTime = Moment(this.backStartTime).format()
      const temp = backStartTime.split('+')
      const backEndTime = this.backEndTime ? Moment(this.backEndTime).format() : Moment().format()
      const temp1 = backEndTime.split('+')
      const query = {
        cameraIndexCode: '',
        recordLocation: 1, // 0：中心存储 1：设备存储
        protocol: this.H5playerProtocol,
        transmode: 1, // 0:UDP 1:TCP
        beginTime: `${temp[0]}.000+${temp[1]}`,
        endTime: `${temp1[0]}.000+${temp1[1]}`,
        expand: 'transcode=0',
        streamform: 'ps',
        lockType: 0, // 0-查询全部录像；1-查询未锁定录像；2-查询已锁定录像
      }
      const backTime = {
        backStartTime: `${
          Moment(this.backStartTime)
            .format()
            .split('+')[0]
        }Z`,
        backEndTime: this.backEndTime
          ? `${
              Moment(this.backEndTime)
                .format()
                .split('+')[0]
            }Z`
          : `${
              Moment()
                .format()
                .split('+')[0]
            }Z`,
      }
      this.$refs.h5Frame.contentWindow.postMessage(
        { playControl: 'backPlay', backTime, backPlayQurey: JSON.stringify(query) },
        '*'
      )
    },
    // 回放相关控制
    playControl(val) {
      if (val === 'pausePlay' || val === 'resumePlay') {
        this.isPausePlay = !this.isPausePlay
      }
      if (val === 'slowPlay' || val === 'fastPlay') {
        this.backSpeed = val === 'slowPlay' ? this.backSpeed / 2 : this.backSpeed * 2
      }
      if (val === 'stopPlay') {
        this.isBackPlay = false
      }
      this.$refs.h5Frame.contentWindow.postMessage(
        { playControl: val, backSpeed: this.backSpeed },
        '*'
      )
    },
    /**
     * @description: 重置回放速度
     * @param {*}
     * @return {*}
     */

    refreshPlay() {
      if (this.backSpeed > 1) {
        this.backSpeed /= 2
        this.$refs.h5Frame.contentWindow.postMessage(
          { playControl: 'slowPlay', backSpeed: this.backSpeed },
          '*'
        )
        setTimeout(() => {
          this.refreshPlay()
        }, 100)
      } else if (this.backSpeed < 1) {
        this.backSpeed *= 2
        this.$refs.h5Frame.contentWindow.postMessage(
          { playControl: 'fastPlay', backSpeed: this.backSpeed },
          '*'
        )
        setTimeout(() => {
          this.refreshPlay()
        }, 100)
      }
    },
    handlerMessage(e) {
      if (e.data.methods === 'playControl') {
        this.$message({
          message: e.data.message,
          type: e.data.type,
        })
        this.isBackPlay = false
      } else if (e.data.methods === 'controlCamera') {
        this.$message({
          message: e.data.message,
          type: e.data.type,
        })
      } else if (e.data.methods === 'iwindChange') {
        if (this.isBackPlay) {
          this.isBackPlay = false
          // 将回放状态的流切换为预览状态的流
          this.$refs.h5Frame.contentWindow.postMessage(
            { playControl: 'priviewPlay', iWind: e.data.preIwind },
            '*'
          )
        }
      }
    },
  },
  mounted() {
    window.onresize = () => {
      this.$refs.h5Frame.contentWindow.postMessage({ isFull: false }, '*')
    }
    window.addEventListener('message', this.handlerMessage, false)
  },
}
</script>
<style lang="scss" scoped>

.h-50 {
  height: 50%;
}
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}
.full_screen {
  bottom: 0px;
  right: 4px;
}
.controlImg {
  width: 30px;
  &_up {
    transform: rotate(90deg);
  }
  &_right {
    margin-left: 50px;
    transform: rotate(180deg);
  }
  &_down {
    transform: rotate(-90deg);
  }
}
/deep/.el-button--primary {
  padding: 6px 13px;
}
.arrows {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  border: 1px solid #ebeef5;
  background: rgba(250, 250, 250, 0.8);
  height: 40%;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
}
.darkStyle {
  .darkStyle_text {
    color: #fff;
  }
  .darkStyle_button {
    /deep/.el-button--primary {
      background-color: #00c0ff;
    }
  }
}
.cur-pointer {
  cursor: pointer;
}

</style>
